import { render } from "./sectionJury.vue?vue&type=template&id=49bef376&scoped=true"
import script from "./sectionJury.vue?vue&type=script&lang=js"
export * from "./sectionJury.vue?vue&type=script&lang=js"

import "./sectionJury.vue?vue&type=style&index=0&id=49bef376&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bef376"]])

export default __exports__